import { useEffect } from 'react';
import type { Address } from 'src/apis/contract-management/types';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  url?: string;
};

type ExecuteProps = {
  url: string;
};

export function useShipperAddress({ url }: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { url }: ExecuteProps) =>
      axios.request<Address>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!url) return;
    request.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, [url]);

  if (!url) return;

  return request;
}

export type ShipperAddressRequest = ReturnType<typeof useShipperAddress>;
